import React from "react";
import { useSiteOffersSliceContext } from "../../../context/SliceContexts/SiteOffersContext";
import { StyledContainer, Subtitle } from "./SiteOffersHelpers";
import { Link, Slice } from "gatsby";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PageOfferList from "../Offers/PageOfferList/PageOfferList";
import TemplateOffersList from "../../common/Offers/TemplateOffersList/TemplateOffersList";

const SiteOffers: React.FC = () => {
  const {
    relationships,
    location,
    field_subtitle,
    field_title,
    field_description,
  } = useSiteOffersSliceContext();

  const offers = relationships?.offers || null;
  const sonsestaOnlyOffers =
    offers &&
    offers.filter(
      (offer: {
        relationships: {
          field_site_list?: { machine_name: string | undefined };
        };
      }) =>
        offer.relationships.field_site_list?.machine_name ==
        process.env.GATSBY_SITE_MACHINE_NAME
    );

  return (
    <StyledContainer>
      <Container fluid="sm" className="p-0">
        {location?.pathname && location.pathname !== "/offers" ? (
          <>
            <Row className="mb-4 mb-md-5">
              <Col className="text-center">
                <Subtitle>{field_subtitle}</Subtitle>
                <h2>{field_title}</h2>
                {field_description && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: field_description,
                    }}
                  />
                )}
                <Link
                  id="explore-all-offers"
                  to="/offers"
                  className="teaser-link"
                >
                  Explore All Offers
                </Link>
              </Col>
            </Row>
            <TemplateOffersList
              offers={sonsestaOnlyOffers}
              location={location}
            />
          </>
        ) : (
          <PageOfferList offers={sonsestaOnlyOffers} location={location} />
        )}
      </Container>
    </StyledContainer>
  );
};

export default SiteOffers;
